/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2025-01-22 07:57:13
 **/

import { PropsWithChildren, CSSProperties } from "react";
import { BarLoader, BeatLoader, ClipLoader, MoonLoader, FadeLoader } from "react-spinners";
import { Choice } from "@/components";

type LengthType = number | string;
export type LoaderProps = {
	type: "bar" | "beat" | "clip" | "moon" | "fade";
} & Partial<{
	color: string;
	loading: boolean;
	cssOverride: CSSProperties;
	speedMultiplier: number;
	height?: LengthType;
	width?: LengthType;
	size?: LengthType;
	margin?: LengthType;
	radius?: LengthType;
}>;

export default function Loader(props: PropsWithChildren<LoaderProps>) {
	const { type = "bar", ...rest } = props;

	return (
		<Choice value={type}>
			<Choice.Case test={"bar"}>
				<BarLoader {...rest} />
			</Choice.Case>
			<Choice.Case test={"beat"}>
				<BeatLoader {...rest} />
			</Choice.Case>
			<Choice.Case test={"clip"}>
				<ClipLoader {...rest} />
			</Choice.Case>
			<Choice.Case test={"moon"}>
				<MoonLoader {...rest} />
			</Choice.Case>
			<Choice.Case test={"fade"}>
				<FadeLoader {...rest} />
			</Choice.Case>
		</Choice>
	);
}
